import React from "react";
import Styles from "./ErrorPage.module.css";
import { ReactComponent as Error } from "../../assets/images/error.svg";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <div className={Styles.errorPageMainContainer}>
      <div className={Styles.errorPageSubContainer}>
        <Error style={{ width: "90%", height: "90%" }} />
        <div className={Styles.errorPagePara}>
          Sorry for the inconvenience, there seems <br /> to be an error.
        </div>
        <div className={Styles.errorPageButton}>
          <div
            className={Styles.errorGoBack}
            onClick={() => {
              navigate("/");
            }}
          >
            Go Back
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
